"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.userTopicFragmentDependencies, fragments_1.userTopicFragment];
const MUTATION = `
query getTopics {
  topics {
    nodes {
      ...userTopicFragment
    }
  }
}
`.trim();
const getTopicsConnection = (0, notifi_axios_utils_1.makeParameterLessRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'topics');
const getTopicsImpl = (axiosInstance) => getTopicsConnection(axiosInstance).then((result) => result.nodes);
exports.default = getTopicsImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0VG9waWNzSW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9xdWVyaWVzL2dldFRvcGljc0ltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FBZ0Y7QUFDaEYsMkVBSTRDO0FBRzVDLE1BQU0sWUFBWSxHQUFHLENBQUMsR0FBRyx5Q0FBNkIsRUFBRSw2QkFBaUIsQ0FBQyxDQUFDO0FBRTNFLE1BQU0sUUFBUSxHQUFHOzs7Ozs7OztDQVFoQixDQUFDLElBQUksRUFBRSxDQUFDO0FBT1QsTUFBTSxtQkFBbUIsR0FBRyxJQUFBLDZDQUF3QixFQUNsRCxJQUFBLHdDQUFtQixFQUFDLEdBQUcsWUFBWSxFQUFFLFFBQVEsQ0FBQyxFQUM5QyxRQUFRLENBQ1QsQ0FBQztBQUVGLE1BQU0sYUFBYSxHQUEyRCxDQUM1RSxhQUFhLEVBQ2IsRUFBRSxDQUFDLG1CQUFtQixDQUFDLGFBQWEsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLE1BQU0sRUFBRSxFQUFFLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBRXZFLGtCQUFlLGFBQWEsQ0FBQyJ9